let routerHistoryLocation

export const routerHistory = {
  getPreviousPath: () => {
    if (!routerHistoryLocation) {
      return undefined
    }
    return routerHistoryLocation
  },
  setPreviousPath: historyLocation => (routerHistoryLocation = historyLocation),
  unsetPath: () => {
    if (routerHistory.getPreviousPath()) {
      routerHistoryLocation = undefined
    }
  },
}



// WEBPACK FOOTER //
// ./src/utils/services/routerHistoryService.ts